import { Badge, Group, Paper, Text } from "@mantine/core";
import type { DrgData } from "../../types/encounter-drg";
import { formatCurrency, getTypeBadgeStyle } from "./helpers";
import {
  DRG_INFO_BOX,
  DRG_INFO_VARIANT,
  FONT,
  TIMELINE_SPACING as TS,
  TW,
} from "./theme";
import type { TimelineVariant } from "./theme";

const DrgInfo = ({
  drg,
  label,
  variant = "neutral",
}: {
  drg: DrgData | null;
  label: string;
  variant?: TimelineVariant;
}) => {
  if (!drg) return null;

  const boxTheme = DRG_INFO_VARIANT[variant] || DRG_INFO_VARIANT.neutral;

  return (
    <Paper
      withBorder
      p={TS.innerPadding}
      style={{
        background: boxTheme.bg,
        borderColor: boxTheme.border,
        borderRadius: TS.innerRadius,
        marginTop: TS.innerMarginTop,
      }}
    >
      <Group justify="space-between" align="center">
        <Group gap="xs">
          <Text size={`${FONT.xs}px`} fw={500} c={DRG_INFO_BOX.labelColor}>
            {label}
          </Text>
          {drg.details?.TYPE && (() => {
            const typeBadge = getTypeBadgeStyle(drg.details.TYPE);
            return (
              <Badge
                size="xs"
                styles={{
                  root: {
                    backgroundColor: typeBadge.bg,
                    color: typeBadge.text,
                    borderColor: typeBadge.border,
                    borderWidth: 1,
                    borderStyle: "solid",
                    height: 16,
                    paddingLeft: 6,
                    paddingRight: 6,
                    fontSize: 10,
                    fontWeight: 500,
                  },
                }}
              >
                {drg.details.TYPE}
              </Badge>
            );
          })()}
        </Group>
        {drg.details?.DOLLARS && (
          <Badge
            size="sm"
            styles={{
              root: {
                backgroundColor: DRG_INFO_BOX.dollarBg,
                color: DRG_INFO_BOX.dollarText,
                borderColor: DRG_INFO_BOX.dollarBorder,
                borderWidth: 1,
                borderStyle: "solid",
                fontSize: FONT.xs,
              },
            }}
          >
            {formatCurrency(drg.details.DOLLARS)}
          </Badge>
        )}
      </Group>
      <Text size={`${FONT.sm}px`} fw={700} c={TW.black} mt={TS.smallMarginTop}>
        {drg.value || "N/A"}
        {drg.description && (
          <Text span size={`${FONT.sm}px`} fw={400} c={TW.gray600}>
            {" "}
            - {drg.description}
          </Text>
        )}
      </Text>
    </Paper>
  );
};

export default DrgInfo;
